import gql from 'graphql-tag';

export const TIMESHEET_WORK_RELATIONS = gql`
  query timesheetWorkRelations($calendarMonth: String!) {
    currentUnit {
      id
      workRelations {
        id
        timesheetComment
        timesheet(calendarMonth: $calendarMonth) {
          id
          paidMinutesSum
        }
        employmentPercentage
        employmentType
        employee {
          id
          firstName
          lastName
        }
        subUnit {
          id
          name
        }
        occupation {
          id
          name
        }
        startDate
        endDate
      }
    }
  }
`;

export const WORK_RELATION_TIMESHEET = gql`
  query workRelationTimesheet($workRelationId: ID!, $calendarMonth: String!) {
    workRelationTimesheet(workRelationId: $workRelationId, calendarMonth: $calendarMonth) {
      id
      calendarMonth
      status
      timeStamps {
        key
        name
        totalMinutes
      }
      days {
        id
        date
        startHhmm
        endHhmm
        breakMinutes
        breaks {
          startHhmm
          endHhmm
        }
        timeStamps {
          key
          startHhmm
          endHhmm
        }
      }
    }
  }
`;

export const SAVE_WORK_RELATION_TIMESHEET = gql`
  mutation saveWorkRelationTimesheet($timesheet: WorkRelationTimesheetSaveAttributes!) {
    saveWorkRelationTimesheet(input: { timesheet: $timesheet }) {
      timesheet {
        id
        calendarMonth
        status
        timeStamps {
          key
          name
          totalMinutes
        }
        days {
          id
          date
          startHhmm
          endHhmm
          breakMinutes
          breaks {
            startHhmm
            endHhmm
          }
          timeStamps {
            key
            startHhmm
            endHhmm
          }
        }
      }
    }
  }
`;

export const SUBMIT_WORK_RELATION_TIMESHEET = gql`
  mutation submitWorkRelationTimesheet($workRelationId: ID!, $calendarMonth: String!) {
    submitWorkRelationTimesheet(input: { workRelationId: $workRelationId, calendarMonth: $calendarMonth }) {
      timesheet {
        id
        calendarMonth
        status
      }
    }
  }
`;

export const SAVE_WORK_RELATION_TIMESHEET_COMMENT = gql`
  mutation saveWorkRelationTimesheetComment($workRelationId: ID!, $timesheetComment: String) {
    saveWorkRelationTimesheetComment(input: { workRelationId: $workRelationId, timesheetComment: $timesheetComment }) {
      workRelation {
        id
        timesheetComment
      }
    }
  }
`;
